import React from "react";

const Faq = () => {
  const faqs = [
    {
      qus: "HOW TO USE",
      Ans: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.",
    },
    {
      qus: "      SUBMISSION GIODLINES",
      Ans: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.",
    },
    {
      qus: "     PAYMENT",
      Ans: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.",
    },
  ];
  return (
    <div className="container my-5">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              HOW TO USE
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit,
              sed do eiusmod. Lorem ipsum dolor sit amet, consectetur
              adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet,
              consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor
              sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem
              ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              SUBMISSION GIODLINES
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit,
              sed do eiusmod. Lorem ipsum dolor sit amet, consectetur
              adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet,
              consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor
              sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem
              ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              PAYMENT
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod. Lorem ipsum dolor sit amet, consectetur adipisicing elit,
              sed do eiusmod. Lorem ipsum dolor sit amet, consectetur
              adipisicing elit, sed do eiusmod. Lorem ipsum dolor sit amet,
              consectetur adipisicing elit, sed do eiusmod. Lorem ipsum dolor
              sit amet, consectetur adipisicing elit, sed do eiusmod. Lorem
              ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
